/**
 * CR-8611: the Cost tab's Future / Historical switch. Split out of CostTab.tsx
 * (500-line rule); the selection itself lives on the dashboard page so the
 * filter panel can offer each sub-tab only its own date ranges.
 */
import type { CostView } from './costViewRanges';

const TABS: Array<{ view: CostView; label: string }> = [
  { view: 'future', label: 'Future' },
  { view: 'historical', label: 'Historical' },
];

interface CostSubTabsProps {
  active: CostView;
  onChange: (view: CostView) => void;
}

export function CostSubTabs({ active, onChange }: CostSubTabsProps) {
  return (
    <div className="border-b">
      <nav className="flex space-x-8 px-6" aria-label="Tabs">
        {TABS.map(({ view, label }) => (
          <button
            key={view}
            onClick={() => onChange(view)}
            className={`whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm ${
              active === view
                ? 'border-primary text-primary'
                : 'border-transparent text-muted-foreground hover:text-foreground hover:border-gray-300'
            }`}
          >
            {label}
          </button>
        ))}
      </nav>
    </div>
  );
}
